(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrusel-testimonios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-review-marquee')) {
    customElements.define('premium-review-marquee', class extends HTMLElement {
      connectedCallback() {
        this.connectFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;
        this.viewport = this.querySelector('.prm__viewport');
        if (!this.viewport) return;
        this.track = this.querySelector('.prm__track');
        this.group = this.querySelector('[data-original]');
        this.button = this.querySelector('.prm__toggle');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.single = this.group.children.length < 2;
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
        this.hovering = false;
        this.focused = false;
        this.visible = true;
        this.classList.toggle('is-single', this.single);
        this.button.hidden = this.single;
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.sync();
        }, options);
        this.viewport.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && this.dataset.hover === 'true') {
            this.hovering = true;
            this.sync();
          }
        }, options);
        this.viewport.addEventListener('pointerleave', () => {
          this.hovering = false;
          this.sync();
        }, options);
        this.viewport.addEventListener('pointerdown', () => {
          this.paused = true;
          this.sync();
        }, options);
        this.viewport.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) > 0 || event.shiftKey) {
            this.paused = true;
            this.sync();
          }
        }, { ...options, passive: true });
        this.viewport.addEventListener('focusin', () => {
          this.focused = true;
          this.sync();
        }, options);
        this.viewport.addEventListener('focusout', (event) => {
          this.focused = this.viewport.contains(event.relatedTarget);
          this.sync();
        }, options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.paused = true;
          this.sync();
          const amount = this.group.firstElementChild.getBoundingClientRect().width;
          if (event.key === 'Home') this.viewport.scrollLeft = 0;
          else if (event.key === 'End') this.viewport.scrollLeft = Math.max(0, this.distance - this.viewport.clientWidth);
          else this.viewport.scrollLeft += event.key === 'ArrowRight' ? amount : -amount;
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          this.paused = true;
          this.sync();
          const card = Array.from(this.group.children).find((item) => item.dataset.blockId === event.detail.blockId);
          if (card) this.viewport.scrollLeft += card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left - 24;
        }, options);
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.paused = true;
          this.build();
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.sync();
        });
        this.intersectionObserver.observe(this);
        this.build();
      }

      build() {
        this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
        this.distance = this.group.getBoundingClientRect().width;
        if (!this.single && this.distance > 0) {
          const copies = Math.ceil(this.viewport.clientWidth / this.distance) + 1;
          for (let index = 0; index < copies; index++) {
            const clone = this.group.cloneNode(true);
            clone.removeAttribute('data-original');
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('*').forEach((node) => {
              node.removeAttribute('id');
              node.removeAttribute('data-block-id');
              Array.from(node.attributes).forEach((attribute) => {
                if (attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
              });
              if (node.matches('a, button, [tabindex]')) node.setAttribute('tabindex', '-1');
            });
            this.track.append(clone);
          }
        }
        this.sync();
      }

      sync() {
        cancelAnimationFrame(this.frame);
        this.classList.toggle('is-paused', this.paused);
        const running = !this.single && !this.paused && !this.hovering && !this.focused && this.visible && !document.hidden && this.distance > 0;
        this.classList.toggle('is-running', running);
        if (!running) return;
        this.position = this.viewport.scrollLeft % this.distance;
        this.lastTime = null;
        const tick = (time) => {
          if (this.lastTime !== null) {
            const elapsed = Math.min(time - this.lastTime, 50);
            const duration = Math.max(10, Number(this.dataset.duration) || 44) * 1000;
            this.position = (this.position + elapsed * this.distance / duration) % this.distance;
            this.viewport.scrollLeft = this.position;
          }
          this.lastTime = time;
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.connectFrame);
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
